/**
 * Google Map directive.
 * Tälä voit liittää sivulle Google Maps-kartan.
 * Directiveen ei liity defaulttityylejä, vaan tyylit on aina määritettävä itse.
 * Tyylit voit määrittää elementin lapselle, #map-canvas elementille.
 *
 * Attribuutit:
 *
 *  name - direktiivi-instanssin nimi, jolla sitä voidaan myöhemmin mistä tahansa hakea GoogleMapServiceltä.
 *  options - Google Maps-API:n mukainen options-objekti (esim. https://developers.google.com/maps/documentation/javascript/examples/control-options)
 *  autocloseInfoboxes - suljetaanko infoboxit automaattisesti kun toinen klikataan auki?
 *  onInit - callback, jota kutsutaan, kun map on luotu. Parametrit:
 *      map - Google Maps-instanssi
 *      controls - kontrollifunktiot tälle direktiivin instanssille
 */
app.directive('googleMap', ["$timeout", "$parse", "$templateCache", "$compile", "GoogleMapService", function($timeout, $parse, $templateCache, $compile, GoogleMapService) {
	return {

		restrict: 'EA',
		templateUrl: 'google-map.html',
		scope: {
			options: '='
		},
		link: function(scope, element, attrs) {

			scope.element = element;
			if(attrs.onInit) {
				scope.onInit = $parse(attrs.onInit);
			}

			scope.autocloseInfoboxes = attrs.autocloseInfoboxes == 'true';

			if(Array.isArray(scope.options.center)) {
				scope.options.center = new google.maps.LatLng(scope.options.center[0], scope.options.center[1]);
			}
			scope.map = new google.maps.Map(element.find('#map-canvas')[0], scope.options);
			scope.mc = new MarkerClusterer(scope.map, [], {
				maxZoom: 13
			});

			// Rekisteröi servicelle, josta tämän saa sitten haettua Get():llä nimen perusteella.
			GoogleMapService.Register(attrs.name, {map: scope.map, controls: scope.controls});

			if(typeof(scope.onInit) != 'undefined') {
				scope.onInit(scope.$parent, {
					map: {map: scope.map, controls: scope.controls}
				});
			}
		},

		controller: ["$scope", function($scope) {

			$scope.infoBoxes = [];
			$scope.placedMarkers = [];

			/**
			 * Google Map -direktiivin kontrollit, jotka ovat näkyvissä ulkopuolelle.
			 * @type {{}}
			 */
			$scope.controls = {};

			/**
			 * Kontrollifunktio: lisää infoboxin annetulle markerille.
			 * Huom: infoboxin scopeen asetetaan scope.infobox, joka on referenssi luotuun Google Maps infoboxiin.
			 * @param marker - Google Maps marker
			 * @param templateFile - template infoboxille
			 * @param data - infoboxin scopeen syötettävä data, joka syötetään scope.info:ksi
			 * @param ibScope - (optional) scope, joka kloonataan uudeksi scopeksi infoboksille
			 * @constructor
			 */
			$scope.controls.AddInfoBox = function(marker, templateFile, data, ibScope) {

				var templateElement = $($templateCache.get(templateFile));
				var infoBoxScope = ibScope ? ibScope.$new() : $scope.$new();
				if(data) {
					infoBoxScope.info = data;
				}
				marker.infoBoxScope = infoBoxScope;

				var compiledInfoBoxElement = $compile(templateElement)(infoBoxScope);

				var infoBoxOptions = {
					content: compiledInfoBoxElement[0],
					disableAutoPan: false,
					maxWidth: 0,
					pixelOffset: new google.maps.Size(0, 0),
					zIndex: null,
					closeBoxURL: "",
					infoBoxClearance: new google.maps.Size(13, 13),
					isHidden: false,
					pane: "floatPane",
					enableEventPropagation: false
				};

				var infoBox = new InfoBox(infoBoxOptions);
				$scope.infoBoxes.push(infoBox);
				infoBoxScope.infobox = infoBox;

				google.maps.event.addListener(marker, 'click', function() {
					if($scope.closing) {
						return false;
					}
					if($scope.autocloseInfoboxes) {
						for(var i = 0; i < $scope.infoBoxes.length; i++) {
							$scope.infoBoxes[i].close();
						}
					}
					$scope.$apply(function() {
						$scope.$emit('infoBoxOpen', infoBoxScope);
						infoBox.open($scope.map, marker);
					});
				});

				infoBoxScope.CloseInfoBox = function() {
					$scope.closing = true;
					setTimeout(function() {
						$scope.closing = false;
					}, 1);
					infoBoxScope.infobox.close();
				};

			};

			$scope.controls.AddMarker = function(latLng, icon, key, group) {
				for(var markerKey in $scope.placedMarkers) {
					if($scope.placedMarkers.hasOwnProperty(markerKey)) {
						if (latLng[0] == $scope.placedMarkers[markerKey].lat && latLng[1] == $scope.placedMarkers[markerKey].lon) {
							return {placedMarker: true, key: markerKey};
						}
					}
				}

				var marker;

				if (group === true) {
					marker = new google.maps.Marker({
						position: new google.maps.LatLng(latLng[0], latLng[1]),
						map: $scope.map,
						icon: icon
					});
				}
				else {
					marker = new google.maps.Marker({
						position: new google.maps.LatLng(latLng[0], latLng[1]),
						icon: icon
					});

					$scope.mc.addMarker(marker, false);
				}

				$scope.placedMarkers[key] = {marker: marker, lat: latLng[0], lon: latLng[1]};

				return marker;
			};

			$scope.controls.GetMarkers = function() {
				return $scope.placedMarkers;
			};
		}]
	};
}]);